import BaseDialog from '~/common/components/dialogs/BaseDialog';

import type { PropsWithChildren } from 'react';

export interface ConfirmProps extends PropsWithChildren {
  title?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
}

function ConfirmDialog({
  title,
  children,
  confirmLabel,
  cancelLabel,
  onCancel,
  onConfirm,
}: ConfirmProps) {
  return (
    <BaseDialog
      title={title}
      cancelText={cancelLabel || '취소'}
      okText={confirmLabel || '확인'}
      onCancel={onCancel}
      onOk={onConfirm}
    >
      {children}
    </BaseDialog>
  );
}

export default ConfirmDialog;
